import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { IconChevronDown } from '@tabler/icons-react';

function NavDropdown({ name, children }) {
	const [isVisible, setVisible] = useState(false);
	const node = useRef();

	const handleToggle = (e) => {
		e.preventDefault();
		setVisible((visible) => !visible);
	};

	const handleClick = (e) => {
		if (!node.current.contains(e.target)) setVisible(false);
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClick);
		return () => {
			document.removeEventListener('mousedown', handleClick);
		};
	}, []);

	return (
		<li className="relative" ref={node}>
			<button
				type="button"
				onClick={handleToggle}
				className={`flex items-center gap-1 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
					isVisible
						? 'bg-[--color-bg-tertiary] text-[--color-text-primary]'
						: 'text-[--color-text-secondary] hover:bg-[--color-bg-secondary] hover:text-[--color-text-primary]'
				}`}
			>
				{name}
				<IconChevronDown
					size={13}
					className={`transition-transform ${isVisible ? 'rotate-180' : ''}`}
				/>
			</button>
			{isVisible && (
				<ul className="absolute left-0 top-full mt-1 w-48 bg-[--color-bg-primary] rounded-[--radius-md] shadow-md border border-[--color-border-subtle] py-1 z-50">
					{children}
				</ul>
			)}
		</li>
	);
}

NavDropdown.propTypes = {
	name: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
};

export default NavDropdown;
